<script>
import { pricingMixin } from '../../mixins/pricingMixin'
import { mapState, mapGetters } from 'vuex'
import Translate from '../../components/translate.vue'
export default {
  mixins: [pricingMixin],
  props: {
    subscription: {
      type: Object,
      required: true,
      default: () => {}
    },
    isSelected: {
      type: Boolean,
      required: true,
      default: true
    },
    isCurrent: {
      type: Boolean,
      required: true,
      default: true
    },
    sub: {
      type: Boolean,
      required: false,
      default: false
    },
    hideSubscribedFlag: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    selectPrice () {
      this.$emit('select-price', this.subscription)
    }
  },
  components: {
    Translate
  },
  computed: {
    ...mapGetters([
      'activeSubscriptionPlan',
      'activeChallenge',
      'hasActiveNativeSubscription',
      'primaryColorRgb'
    ]),
    ...mapState([
      'subscriptions'
    ]),
    priceInterval () {
      const { interval, interval_count: intervalCount } = this.subscription
      if (interval === 'year') { return 'checkout.annually' }
      if (interval === 'month') { if (intervalCount === 1) { return 'checkout.monthly' } if (intervalCount === 3) { return 'checkout.quarterly' } if (intervalCount === 6) { return 'checkout.biannual' } }
      if (interval === 'week') { return 'checkout.weekly' }
      if (interval === 'day') { return 'checkout.daily' } else {
        return ''
      }
    },
    currencySymbol () {
      const currency = this.subscription.currency.toUpperCase()
      return this.currency_symbols[currency]
    },
    getAnnualSavingPercentage () {
      if (this.subscriptions && this.subscriptions.length > 0 && this.subscriptions[0].plans && this.subscriptions[0].plans.length > 0) {
        const plans = this.subscriptions[0].plans
        let monthlyPrice
        let annualPrice
        plans.forEach(subscription => {
          if (this.$_getPlanNickName(subscription) === 'monthly') {
            monthlyPrice = subscription
          }
          if (this.$_getPlanNickName(subscription) === 'annually') {
            annualPrice = subscription
          }
        })
        const percentage = 100 - ((annualPrice.amount / (monthlyPrice.amount * 12)) * 100)

        return Math.round(percentage)
      } else {
        return null
      }
    },
    shouldShowCard () {
      return !this.sub || (!this.activeSubscriptionPlan && !this.hasActiveNativeSubscription) ||
      (this.activeSubscriptionPlan && (this.activeSubscriptionPlan.interval === 'year'
        ? this.activeSubscriptionPlan.id === this.subscription.id
        : this.activeSubscriptionPlan.id !== this.subscription.id
      ))
    },
    subscribedAnnual () {
      return this.activeSubscriptionPlan && this.$_getPlanNickName(this.activeSubscriptionPlan) === 'annually'
    }
  }
}
</script>

<template>
  <div
    v-if="shouldShowCard"
    :class="['price-card', {selected: isSelected && (!sub || !subscribedAnnual)}]"
    @click.stop="selectPrice"
    :style="{
      '--primaryColor': `rgba(${primaryColorRgb}, ${1})`,
      '--primaryColorFaded': `rgba(${primaryColorRgb}, ${0.2})`,
    }"
  >
    <span class="select" v-if="(sub && !activeSubscriptionPlan) || !sub"></span>
    <p class="item-name">
      <span v-if="!sub">{{ activeChallenge.name}}</span>
      <span v-else><Translate :directive="priceInterval" /></span>
      <span
        class="saving-text"
        v-if="subscription.interval == 'year' && !isCurrent"
      > <Translate directive="checkout.bestvalue.annual" /> <span class="highlight">{{ getAnnualSavingPercentage }}%!</span>
      </span>
    </p>
    <button
      v-if="sub && subscribedAnnual"
      class="subscribed-annual"
    >
      Subscribed
    </button>
    <p class="price" v-else>{{currencySymbol}}{{subscription.amount / 100 }}</p>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.price-card {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #B9BBBE;
  border-radius: 8px;
  padding: 32px 16px;
  cursor: pointer;
  margin-bottom: 16px;
  .item-name {
    margin-right: auto;
    margin-bottom: 0;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    font-size: 20px;
    .saving-text {
      font-size: 14px;
      line-height: 120%;
      .highlight {
        color: #449DB4;
      }
    }
  }
  .price {
    margin-bottom: 0;
    font-size: 20px;
  }
  .select {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid rgba(79, 85, 92, 0.4);
    flex-shrink: 0;
  }
  &.selected {
    background: var(--primaryColorFaded);
    border-color: var(--primaryColor);
    .select {
      border: 4px solid var(--primaryColor);
      background: #fff;
    }
  }
  .subscribed-annual {
    background: var(--primaryColorFaded);
    border-color: var(--primaryColor);
    border: 1px solid var(--primaryColor);
  }
  @media screen and (max-width: 800px) {
    padding: 16px;
    .item-name {
      font-size: 16px;
      .saving-text {
        font-size: 12px;
      }
    }
    .price {
      font-size: 16px;
    }
  }
}

</style>
